// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"styles_skeleton__Pk9Yy","loading":"styles_loading__HRcDl"};